import { create } from "zustand";
import axios from "axios";

const statusStore = create((set, get) => ({
    status: [],

    statusForm: {
        seriesId: "",
        userStatus: "",
        rating: "",
        note: "",
        tags: [],
    },

    setStatusField: (field, value) =>
        set((state) => ({
        statusForm: { ...state.statusForm, [field]: value },
    })),

    fetchStatus: async () => {
        // Fetch the status
        const res = await axios.get("/status");

        // Set to state
        set({ status: res.data.statuses || [] });
    },


    // fetchEpisodeStatusesBySeries: async(seriesId)=> {
    //     const state = get();
    //     try {
    //         const res = await axios.get(`/status/series/test/${seriesId}`, {
    //             method: "GET",
    //             credentials: "include" // needed if using cookie auth
    //         });

    //         const data = await res.json();

    //         // Update in local state
    //         set({ status: res.data.statuses || [] });
    //         return data.statuses;

    //     } catch (err) {
    //         console.error(err);
    //     }
    // },
    fetchEpisodeStatusesBySeries: async (seriesId) => {
        try {
            const res = await axios.get(`/status/series/test/${seriesId}`, {
                withCredentials: true, // axios uses this, not `credentials`
            });

            console.log("res ", res);
            return res.data.statuses || [];
            // set to state later
        } catch (err) {
            console.error(err);
            return [];
        }
    },
 

    //NEW
    fetchEpisodeStatuses: async (seriesId) => {
        const state = get();
        try {
            const res = await axios.get(`/status/episodes/${seriesId}`, {
                method: "GET",
                credentials: "include" // needed if using cookie auth
            });

            const data = await res.json();

            // Update in local state
            set({ status: res.data.statuses || [] });
            return data.statuses;

        } catch (err) {
            console.error(err);
        }
    },

    createEpisodeStatus: async(seriesId, season, episode, targetId, targetType, userStatus, rating, review, tags) => {
        try {
            let res = await axios.post(`/status`, { seriesId, season, episode, targetId, targetType, userStatus, rating, review, tags });

            // Add new one to local state
            set((state) => ({
                status: [...state.status, res.data.status]
            }));
            
        } catch (err) {
            console.log("Error");
            return err;
        }
    },

    updateEpisodeStatus: async(statusId, seriesId, season, episode, targetId, targetType, userStatus, rating, review, tags) => {

        const state = get();  
        try {
            let res = await axios.put(`/status/${statusId}`, 
                { seriesId, season, episode, targetId, targetType, userStatus, rating, review, tags });

            // Update in local state
            set({
                status: state.status.map((s) =>
                    s._id === statusId ? { ...s, userStatus } : s
                ),
            });
        } catch (err) {
            console.log("Error");
            return err;
        }
    },

    createSeriesStatus: async(seriesId, season, episode, targetId, userStatus, rating, review, tags) => {
        const state = get();
        try {
            let res = await axios.post(`/status`, { seriesId, season, episode, targetId,  targetType: "series", userStatus, rating, review, tags });
            // Add new one to local state
            //set({ status: [...state.status, res.data] });
        } catch (err) {
            console.log("Error");
            return err;
        }
    },

    
    updateSeriesStatus: async (seriesId, userStatus, airingStatus) => {
        const state = get();

        // Find existing status for this series
          const existingStatus = state.status.find(
            (s) => s.targetType === "series" && s.seriesId === seriesId
        );

        // Fix user status language if on the getstarted page
        if (airingStatus === "Continuing" && userStatus === "Finished") {
            userStatus = "Finished what's available";
        }
        
        if (existingStatus !== "Not Interested") {
            try {
                let res;

                if (existingStatus) {
                    // Update existing status 
                    res = await axios.put(`/status/${existingStatus._id}`, { seriesId, targetType: "series", userStatus });

                    // Update in local state
                    set({
                        statuses: state.status.map((s) =>
                            s._id === existingStatus._id ? { ...s, userStatus } : s
                        ),
                    });
                    console.log("Status updated:", res.data);
                } else {
                    // Create new status
                    res = await axios.post(`/status`, { seriesId, targetType: "series", userStatus });

                    // Add new one to local state
                    set({ statuses: [...state.status, res.data] });
                    console.log("New status created:", res.data);
                }
            } catch (err) {
                console.error("Error saving status:", err);
            }
        } else if (existingStatus === "Not interested") {
            // Delete the status 
            try {
                let res;
                res = await axios.delete(`/status/${existingStatus._id}`);
            } catch (err) {
                console.error("Error deleting status:", err);
            }    
        }
    },
    // updateStatus: async (seriesId, userStatus, airingStatus) => {
    //     const state = get();

    //     // Find existing status for this series
    //     const existingStatus = state.status.find((s) => s.seriesId === seriesId);

    //     // Fix user status language if on the getstarted page
    //     if (airingStatus === "Continuing" && userStatus === "Finished") {
    //         userStatus = "Finished what's available";
    //     }
        
    //     if (existingStatus !== "Not Interested") {
    //         try {
    //             let res;

    //             if (existingStatus) {
    //                 // Update existing status 
    //                 res = await axios.put(`/status/${existingStatus._id}`, { seriesId, userStatus });

    //                 // Update in local state
    //                 set({
    //                     statuses: state.status.map((s) =>
    //                         s._id === existingStatus._id ? { ...s, userStatus } : s
    //                     ),
    //                 });
    //                 console.log("Status updated:", res.data);
    //             } else {
    //                 // Create new status
    //                 res = await axios.post(`/status`, { seriesId, userStatus });

    //                 // Add new one to local state
    //                 set({ statuses: [...state.status, res.data] });
    //                 console.log("New status created:", res.data);
    //             }
    //         } catch (err) {
    //             console.error("Error saving status:", err);
    //         }
    //     } else if (existingStatus === "Not interested") {
    //         // Delete the status 
    //         try {
    //             let res;
    //             res = await axios.delete(`/status/${existingStatus._id}`);
    //         } catch (err) {
    //             console.error("Error deleting status:", err);
    //         }    
    //     }
    // },

}));

export default statusStore;